export default __webpack_public_path__ + "static/media/logo.e4dc4200.png";